import routerIcon from "../assets/icons/ic_router.png";
import switchIcon from "../assets/icons/ic_l3_switch.png";
import hostIcon from "../assets/icons/ic_host.png";
import printerIcon from "../assets/icons/ic_printer.png";
import hostVmIcon from "../assets/icons/ic_host_vm.png";
import sensorIcon from "../assets/icons/ic_sensor.png";
import vmIcon from "../assets/icons/ic_vm.png";
import databaseIcon from "../assets/icons/ic_database.png";
import firewallIcon from "../assets/icons/ic_firewall.png";
import cdnIcon from "../assets/icons/ic_cdn.png";
import proxyIcon from "../assets/icons/ic_proxy.png";
import vpnIcon from "../assets/icons/ic_vpn.png";
import modemIcon from "../assets/icons/ic_modem.png";
import pcIcon from "../assets/icons/ic_pc.png";
import customDeviceIcon from "../assets/icons/ic_custom_device.png";

const NODE_TYPE_CONFIGS = [
  {
    type: "router",
    labelKey: "topology.devices.router",
    defaultLabel: "Router",
    icon: routerIcon,
    category: "Networking",
  },
  {
    type: "switch",
    labelKey: "topology.devices.switch",
    defaultLabel: "Switch",
    icon: switchIcon,
    category: "Networking",
  },
  {
    type: "firewall",
    labelKey: "topology.devices.firewall",
    defaultLabel: "Firewall",
    icon: firewallIcon,
    category: "Security",
  },
  {
    type: "vpn",
    labelKey: "topology.devices.vpn",
    defaultLabel: "VPN",
    icon: vpnIcon,
    category: "Security",
  },
  {
    type: "proxy",
    labelKey: "topology.devices.proxy",
    defaultLabel: "Proxy",
    icon: proxyIcon,
    category: "Security",
  },
  {
    type: "host",
    labelKey: "topology.devices.host",
    defaultLabel: "Host",
    icon: hostIcon,
    category: "Compute",
  },
  {
    type: "host_vm",
    labelKey: "topology.devices.host_vm",
    defaultLabel: "Host VM",
    icon: hostVmIcon,
    category: "Compute",
  },
  {
    type: "vm",
    labelKey: "topology.devices.vm",
    defaultLabel: "VM",
    icon: vmIcon,
    category: "Compute",
  },
  {
    type: "database",
    labelKey: "topology.devices.database",
    defaultLabel: "Database",
    icon: databaseIcon,
    category: "Compute",
  },
  {
    type: "printer",
    labelKey: "topology.devices.printer",
    defaultLabel: "Printer",
    icon: printerIcon,
    category: "Compute",
  },
  {
    type: "sensor",
    labelKey: "topology.devices.sensor",
    defaultLabel: "Sensor",
    icon: sensorIcon,
    category: "Compute",
  },
  {
    type: "cdn",
    labelKey: "topology.devices.cdn",
    defaultLabel: "CDN",
    icon: cdnIcon,
    category: "Networking",
  },
  {
    type: "custom_device",
    labelKey: "topology.devices.custom_device",
    defaultLabel: "Custom Device",
    icon: customDeviceIcon,
    category: "Compute",
  },
];

export const getNodeTypes = (t) =>
  NODE_TYPE_CONFIGS.map(({ type, labelKey, defaultLabel, icon, category }) => ({
    type,
    icon,
    category,
    label: t ? t(labelKey, defaultLabel) : defaultLabel,
  }));

export const getNodeTypeConfig = (type) =>
  NODE_TYPE_CONFIGS.find((config) => config.type === type);

/** Fallback icon when API has no icon. */
export { customDeviceIcon };

/** Category-based fallback icons for API device types. */
export const categoryFallbackIcons = {
  "Application Services": proxyIcon,
  "Compute & Virtualization": hostVmIcon,
  "DevOps & Development": hostIcon,
  "Identity & Access Management": vpnIcon,
  "IoT & Sensors": sensorIcon,
  "Monitoring & Management": hostIcon,
  "Network Infrastructure": routerIcon,
  "OT/ICS - Control Systems": modemIcon,
  "OT/ICS - Field Devices & Instrumentation": sensorIcon,
  "Other / Special Purpose": customDeviceIcon,
  "Safety Systems": firewallIcon,
  Security: firewallIcon,
  "Storage & Backup": databaseIcon,
  "User/Endpoints": pcIcon,
};

export const getCategoryFallbackIcon = (category) =>
  categoryFallbackIcons[category] || customDeviceIcon;

export const initialNodes = [];
export const initialEdges = [];
